import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { Dialog } from "primereact/dialog";
import TabHeader from "../common/TabHeader";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import CheckboxInput from "../common/CheckBoxInput";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";
import { TEXT_NORMAL } from "../../style";

export default function DialogEditBranch({ visible, setBranches, closeDialog, id, title, address, description, active }) {
    const { requestAPI, showToast } = useAppContext();

    const [branch, setBranch] = useState({
        title,
        address,
        description,
        active,
    });
    const [loading, setLoading] = useState();

    const editBranch = useCallback(() => {
        requestAPI({
            requestPath: `branches`,
            requestMethod: "PATCH",
            requestPostBody: {
                id,
                title: branch?.title,
                address: branch?.address,
                description: branch?.description,
                active: !!branch?.active,
            },
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Branch !", life: 2000 }),
            onResponseReceieved: (updated, responseCode) => {
                if (updated && responseCode === 200) {
                    showToast({ severity: "success", summary: "Updated", detail: "Branch Updated", life: 1000 });
                    setBranches((prev) => prev?.map((item) => (item?.id === id ? updated : item)));
                    closeDialog();
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: updated?.error || "Failed To Update Branch !", life: 2000 });
                }
            },
        });
    }, [branch, closeDialog, id, requestAPI, setBranches, showToast]);

    return (
        <Dialog pt={{ content: { className: "overflow-y-auto" } }} header="Edit Branch" visible={visible} className="w-11" onHide={closeDialog}>
            <TabHeader className="pt-3" title="Edit Branch" />

            <FloatLabel className="mt-5">
                <InputText
                    value={branch?.title || ""}
                    id="title"
                    className="w-full"
                    onChange={(e) => setBranch((prev) => ({ ...prev, title: e.target.value }))}
                    disabled={loading}
                    pt={{ root: { className: TEXT_NORMAL } }}
                />
                <label htmlFor="title">Title</label>
            </FloatLabel>

            <FloatLabel className="mt-5">
                <InputText
                    value={branch?.address || ""}
                    id="address"
                    className="w-full"
                    onChange={(e) => setBranch((prev) => ({ ...prev, address: e.target.value }))}
                    disabled={loading}
                    pt={{ root: { className: TEXT_NORMAL } }}
                />
                <label htmlFor="address">Address</label>
            </FloatLabel>

            <FloatLabel className="mt-5">
                <InputTextarea
                    value={branch?.description || ""}
                    id="description"
                    rows={3}
                    className="w-full"
                    onChange={(e) => setBranch((prev) => ({ ...prev, description: e.target.value }))}
                    disabled={loading}
                    pt={{ root: { className: TEXT_NORMAL } }}
                />
                <label htmlFor="description">Description</label>
            </FloatLabel>

            <CheckboxInput
                className="mt-3"
                label="Active"
                checked={!!branch?.active}
                onChange={(checked) => setBranch((prev) => ({ ...prev, active: checked }))}
            />

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_BRANCH}>
                <Button
                    className="mt-3"
                    label="Update Branch"
                    severity="warning"
                    loading={loading}
                    onClick={editBranch}
                    disabled={!branch?.title?.trim() || !branch?.address?.trim() || !branch?.description?.trim()}
                />
            </HasRequiredAuthority>
        </Dialog>
    );
}
